import coords from 'country-coords';
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from 'react-simple-maps';

import Tooltip from '~/components/RedesignedTooltip';

import Bit from './Bit';
import geography from './world-110m.json';

const colors = ['#148cfc', '#c363e5', '#e29bf3', '#637eff', '#3abefa'];

const color = (index) => {
  return colors[index % colors.length];
};

const MapBit = ({ markers, title, ...props }) => {
  return (
    <Bit {...props} padding={false}>
      <Bit.Title>{title}</Bit.Title>
      <ComposableMap
        height={400}
        projection="geoMercator"
        data-tip=""
        projectionConfig={{
          scale: 90,
          rotate: [-12, 0, 0],
          center: [0, -680],
        }}>
        <Geographies geography={geography}>
          {({ geographies }) =>
            geographies
              .filter(
                (geography) => geography.properties.REGION_UN !== 'Antarctica',
              )
              .map((geography) => (
                <Geography
                  style={{
                    default: { outline: 'none' },
                    hover: { outline: 'none' },
                    pressed: { outline: 'none' },
                  }}
                  key={geography.rsmKey}
                  geography={geography}
                  fill="#EAEAEC"
                  stroke="#D6D6DA"
                />
              ))
          }
        </Geographies>
        {markers.map(({ code, count, name }, index) => {
          const country = coords.byCountry().get(code);
          const radius = 3 + Math.pow(Math.log10(count), 2.5);
          if (!country) return null;
          return (
            <Tooltip key={code} title={`${name}: ${count.toLocaleString()}`}>
              <Marker coordinates={[country.longitude, country.latitude]}>
                <circle
                  r={radius}
                  fill={`${color(index)}9C`}
                  stroke={`${color(index)}90`}
                  strokeWidth={2}
                />
              </Marker>
            </Tooltip>
          );
        })}
      </ComposableMap>
    </Bit>
  );
};

MapBit.propTypes = {
  markers: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  ),
  title: PropTypes.string,
};

export default MapBit;
